<template>
  <Modal :visible="visible"
         :style="computedWindowSize"
         class="p-fluid"
         @close="close">
    <template v-slot:header>
      <div class="p-dialog-title">{{ $t('possibleDuplicatesFoundTitle') }}</div>
    </template>
    <template v-if="items?.length">
      <div class="p-d-flex p-ai-center p-mb-4">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
        <div><div>{{ $t('possibleDuplicatesFoundMsg') }}</div></div>
      </div>
      <div class="table-wrapper">
        <table class="p-datatable p-datatable-striped p-datatable-sm p-datatable-hoverable-rows">
          <template v-if="type === 'warehouseItem'">
            <thead class="p-datatable-thead">
            <tr>
              <th>{{ $t('Code') }}</th>
              <th>{{ $t('Name') }}</th>
              <th>{{ $t('Purchase price') }}</th>
              <th>{{ $t('Selling price') }}</th>
              <th></th>
            </tr>
            </thead>
            <tbody class="p-datatable-tbody">
            <tr v-for="item of items" :key="item.id">
              <td>
                <span v-if="item.code">{{ item.code }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.name">{{ item.name }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span>{{ formatCurrency(item.purchase_price, 2 ,4) }}</span>
              </td>
              <td>
                <span>{{ formatCurrency(item.sell_price, 2 ,4) }}</span>
              </td>
              <td style="text-align: right">
                <Button :label="$t('Select')"
                        @click="selectItem(item)"
                        class="p-button-raised"
                        style="width: auto;"/>
              </td>
            </tr>
            </tbody>
          </template>

          <template v-else-if="type === 'service'">
            <thead class="p-datatable-thead">
            <tr>
              <th>{{ $t('Code') }}</th>
              <th>{{ $t('Name') }}</th>
              <th>{{ $t('Selling price') }}</th>
              <th></th>
            </tr>
            </thead>
            <tbody class="p-datatable-tbody">
            <tr v-for="item of items" :key="item.id">
              <td>
                <span v-if="item.code">{{ item.code }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.name">{{ item.name }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span>{{ formatCurrency(item.sell, 2 ,4) }}</span>
              </td>
              <td style="text-align: right">
                <Button :label="$t('Select')"
                        @click="selectItem(item)"
                        class="p-button-raised"
                        style="width: auto;"/>
              </td>
            </tr>
            </tbody>
          </template>

          <template v-else-if="type === 'supplier'">
            <thead class="p-datatable-thead">
            <tr>
              <th>{{ $t('Company name') }}</th>
              <th>{{ $t('Name') }}</th>
              <th>{{ $t('Reg. number') }}</th>
              <th>{{ $t('VAT number') }}</th>
              <th></th>
            </tr>
            </thead>
            <tbody class="p-datatable-tbody">
            <tr v-for="item of items" :key="item.id">
              <td>
                <span v-if="item.company_name">{{ item.company_name }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.name">{{ item.name }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.reg_number">{{ item.reg_number }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.vat_number">{{ item.vat_number }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td style="text-align: right">
                <Button :label="$t('Select')"
                        @click="selectItem(item)"
                        class="p-button-raised"
                        style="width: auto;"/>
              </td>
            </tr>
            </tbody>
          </template>


          <template v-else-if="type === 'vehicle'">
            <thead class="p-datatable-thead">
            <tr>
              <th>{{ $t('Plate number') }}</th>
              <th>{{ $t('Make') }}</th>
              <th>{{ $t('Model') }}</th>
              <th>{{ $t('Year') }}</th>
              <th>
                <span v-if="!$store.getters.isForkliftTenant">{{ $t('VIN number') }}</span>
                <span v-else>{{ $t('Serial Number') }}</span>
              </th>
              <th></th>
            </tr>
            </thead>
            <tbody class="p-datatable-tbody">
            <tr v-for="item of items" :key="item.id">
              <td>
                <span v-if="item.plate_number">{{ item.plate_number }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.custom_make || item.make?.name">{{ item.custom_make || item.make?.name }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.custom_model || item.model?.name">{{ item.custom_model || item.model?.name }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.year">{{ item.year }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <template v-if="!$store.getters.isForkliftTenant">
                  <span v-if="item.vin">{{ item.vin }}</span>
                  <i v-else class="ti-minus"/>
                </template>
                <template v-else>
                  <span v-if="item.serial_number">{{ item.serial_number }}</span>
                  <i v-else class="ti-minus"/>
                </template>
              </td>
              <td style="text-align: right">
                <Button :label="$t('Select')"
                        @click="selectItem(item)"
                        class="p-button-raised"
                        style="width: auto;">
                </Button>
              </td>
            </tr>
            </tbody>
          </template>


          <template v-else-if="type === 'customer'">
            <template v-if="thereIsCompanyInDuplicates">
              <thead class="p-datatable-thead">
              <tr>
                <th>{{ $t('Company name') }}</th>
                <th>{{ $t('Reg. number') }}</th>
                <th>{{ $t('VAT number') }}</th>
                <th>{{ $t('Invoice Email') }}</th>
                <th></th>
              </tr>
              </thead>
              <tbody class="p-datatable-tbody">
              <tr v-for="item of items" :key="item.id">
                <td>
                  <span v-if="item.company_name">{{ item.company_name }}</span>
                  <i v-else class="ti-minus"/>
                </td>
                <td>
                  <span v-if="item.reg_number">{{ item.reg_number }}</span>
                  <i v-else class="ti-minus"/>
                </td>
                <td>
                  <span v-if="item.vat_number">{{ item.vat_number }}</span>
                  <i v-else class="ti-minus"/>
                </td>
                <td>
                  <span v-if="item.email">{{ item.email }}</span>
                  <i v-else class="ti-minus"/>
                </td>
                <td style="text-align: right">
                  <Button :label="$t('Select')"
                          @click="selectItem(item)"
                          class="p-button-raised" style="width: auto;"/>
                </td>
              </tr>
              </tbody>
            </template>

            <template v-else>
              <thead class="p-datatable-thead">
              <tr>
                <th>{{ $t('First name') }}</th>
                <th>{{ $t('Last name') }}</th>
                <th>{{ $t('Phone') }}</th>
                <th>{{ $t('Email') }}</th>
                <th></th>
              </tr>
              </thead>
              <tbody class="p-datatable-tbody">
              <tr v-for="item of items" :key="item.id">
                <td>
                  <span v-if="item.first_name">{{ item.first_name }}</span>
                  <i v-else class="ti-minus"/>
                </td>
                <td>
                  <span v-if="item.last_name">{{ item.last_name }}</span>
                  <i v-else class="ti-minus"/>
                </td>
                <td>
                  <span v-if="item.phone_code && item.phone_number">+{{ item.phone_code }} {{ item.phone_number }}</span>
                  <i v-else class="ti-minus"/>
                </td>
                <td>
                  <span v-if="item.email">{{ item.email }}</span>
                  <i v-else class="ti-minus"/>
                </td>
                <td style="text-align: right">
                  <Button :label="$t('Select')"
                          @click="selectItem(item)"
                          class="p-button-raised"
                          style="width: auto;"/>
                </td>
              </tr>
              </tbody>
            </template>
          </template>


          <template v-else>
            <div class="p-pt-4 p-pb-4 p-d-flex p-jc-center p-ai-center">{{ $t('No data available') }}</div>
          </template>

        </table>
      </div>


      <div class="p-d-flex p-ai-center p-flex-wrap p-mt-3" v-if="allowCreateNewAnyway">
        <div class="p-d-flex p-ai-center p-mr-3" style="min-height: 36px;">
          <Checkbox id="create-new-anyway-checkbox" :binary="true" v-model="createNewAnyway"/>
          <label for="create-new-anyway-checkbox" class="pointer p-ml-2">
            {{ itemId ? $t('changeDataAnywayLabel') : $t('createNewAnywayLabel') }}
          </label>
        </div>
        <Button v-if="createNewAnyway"
                @click="createNew"
                :label="itemId ? $t('Change') : $t('Create new')"
                class="p-button-raised p-button-warning"
                style="width: auto;"/>
      </div>

    </template>
    <template #footer>
      <Button :label="$t('Close')" icon="pi pi-times" class="p-button-text" @click="close"/>
    </template>
  </Modal>
</template>

<script>
import formatMixins from "@/mixins/formatMixins";

export default {
  mixins: [formatMixins],
  name: 'ItemExistsModal',
  emits: ['close', 'confirm', 'create-new-anyway', 'select-existing'],
  props: {
    type: {
      type: String,
      default: ''
    },
    allowCreateNewAnyway: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => [],
    },
    // data: String,
    // header: null,
    // footer: null,
    visible: {
      type: Boolean,
      default: false,
    },
    // style: Object,
    itemId: {
      type: [Number, String],
      default: null,
    },
  },
  watch: {
    visible() {
      if (!this.visible) {
        this.createNewAnyway = false
      }
    }
  },
  data() {
    return {
      createNewAnyway: false,
    }
  },
  methods: {
    selectItem(item) {
      this.$emit('select-existing', item)
      this.close()
    },
    createNew() {
      this.$emit('create-new-anyway')
      this.close()
    },
    close() {
      this.$emit('close')
    },
    confirm() {
      this.$emit('confirm')
    }
  },
  computed: {
    thereIsCompanyInDuplicates() {
      return this.type === 'customer' && this.items?.find(i => i.type === 2)
    },
    computedWindowSize() {
      if (this.$store.state.mobileLayout) {
        return {position: 'absolute', top: 0, width: '95%', marginTop: '35px'}
      } else if (!this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'absolute', top: 0, width: '95%', maxWidth: '750px', marginTop: '35px'}
      } else {
        return {position: 'absolute', top: 0, width: '750px', marginTop: '25px'}
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.table-wrapper {
  overflow-y: auto;
}

.p-datatable {
  width: 100%;
  border-collapse: collapse;
}
</style>